import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const PresentationApp = lazy(() => import('./Presentation'));

const PresentationConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/presentation',
      element: <PresentationApp />,
    },
  ],
};

export default PresentationConfig;
